import { CompanyService, CompanyId } from './../../services/company.service';
import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { toast, MaterializeAction } from 'angular2-materialize';
import { ProductionOrderService, ProductionOrderId, ProductionOrderData, OdpActivity } from '../../services/production-order.service';
import { PurchaseOrderService, PurchaseOrder, PurchaseOrderId, PrForOrders } from '../../services/purchase-order.service';
import { CustomerBillService, CustomerBillData, CustomerBillId } from '../../services/customer-bill.service';
import { Subscription, Observable } from 'rxjs';
import { Utils } from '../../util';
import { ProductCmpaService, PrCmpa, PrCmpaId } from '../../services/product-cmpa.service';
import { EmployeeId, EmployeeService } from '../../services/employee.service';
import { PdfTemplates } from '../../pdfTemplates';
import { SupplierBill, SupplierBillService, Justification, SupplierBillId } from '../../services/supplier-bill.service';
import { OutcomedBill } from '../../services/outcome.service';
import { setLocaleDayOfWeek } from 'ngx-bootstrap/chronos/units/day-of-week';
import { OdpPriorityComponent } from '../../production-order/odp-priority/odp-priority.component';
import { stringify } from 'querystring';
import { JobService, JobId } from '../../services/job.service';
import { BsDatepickerInputDirective } from 'ngx-bootstrap/datepicker/bs-datepicker-input.directive';
import { ActivityClassificationService } from '../../services/activity-classification.service';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { PrTypeId, ProductTypeService, PrTypeData } from '../../services/product-type.service';
import { ExpenseCategory, ExpenseCategoryService } from '../../services/expense-category.service';
import { SelectOption, RowSorter, Column } from '../../globals';
import { find } from 'lodash';

type OdcPr = {odcId: string, odcFolio: number, odcChange: number, reportKey: RentabilityReportComponent['reportKeys'][number]} & PurchaseOrderId['prForOrders'][0];
type Odp = {odcPrs: OdcPr[], bills: CustomerBillId[]} & ProductionOrderId;
type RentabilityRow = {
  odpDate: string,
  odpFolio: string,
  odpShortDescription: string,
  odpStatus: string,
  billsPrUnit: number,
  odpQuantity: number,
  billsQuantity: number,
  quantityPercentage: number,
  billsAmount: number,
  billsNdcsSubtotal: number,
  report: {[K in RentabilityReportComponent['reportKeys'][number]]: number},
  mdo: number,
  expenseCategorys: {[categoryName: string]: number},
  totalExpenses: number,
  grossProfit: number,
  opensModal: boolean,
}

@Component({
  selector: 'app-rentability-report',
  templateUrl: './rentability-report.component.html',
  styleUrls: ['./rentability-report.component.css']
})
export class RentabilityReportComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};
  loaded: boolean = true;

  reportKeys = ['key1', 'key2', 'key3', 'key4'] /* as const */;

  odps: {[id: string]: Odp} = {};
  docs = {
    odps: <ProductionOrderId[]>[],
    bills: <CustomerBillId[]>[],
    supBills: <SupplierBillId[]>[],
    expenseCategorys: <ExpenseCategory[]>[],
    odcs: <PurchaseOrderId[]>[],
    prCmpas: <PrCmpaId[]>[],
    prTypes: <PrTypeId[]>[],
    employees: <EmployeeId[]>[],
    jobs: <JobId[]>[],
    company: <CompanyId> null,
  };

  initialDate: string = '';
  finalDate: string = Utils.today;
  customerId: string = '';
  customerSelect: SelectOption[] = [];

  sorter: RowSorter<RentabilityRow>;

  firstPulled = {
    odps: '',
    supBills: '',
  };
  subs: {[K in keyof RentabilityReportComponent['docs']]?: Subscription} = {};

  _columnBones: Column<RentabilityRow>[] = [
    {name: 'Fecha', key: 'odpDate', pipe: ''},
    {name: 'Proyecto', key: 'odpFolio', pipe: ''},
    {name: 'Descripción', key: 'odpShortDescription', pipe: ''},
    {name: 'Estatus', key: 'odpStatus', pipe: ''},
    {name: 'Pr Unit', key: 'billsPrUnit', pipe: 'currency'},
    {name: 'Cant Pzas', key: 'odpQuantity', pipe: ''},
    {name: 'Pzas Fact', key: 'billsQuantity', pipe: ''},
    {name: 'Pje Fact', key: 'quantityPercentage', pipe: 'percent'},
    {name: 'Venta', key: 'billsAmount', pipe: 'currency'},
    {name: 'NdC', key: 'billsNdcsSubtotal', pipe: 'currency'},
    {name: '', key: 'report', pipe: 'currency'},
    {name: 'MdO', key: 'mdo', pipe: 'currency'},
    {name: '', key: 'expenseCategorys', pipe: 'currency'},
    {name: 'Gastos', key: 'totalExpenses', pipe: 'currency'},
    {name: 'Utilidad bruta', key: 'grossProfit', pipe: 'currency'},
  ];
  columns: Column<RentabilityRow>[] = [];

  pickadateParams = Utils.pickadateParams();

  money(n){ return Utils.money(n) };
  constructor(
    private service: ProductionOrderService,
    private data: ProductionOrderData,
    private firestoreService: FirestoreService,
    private billService: CustomerBillService,
    private supBillService: SupplierBillService,
    private expenseCategoryService: ExpenseCategoryService,
    private odcService: PurchaseOrderService,
    private prCmpaService: ProductCmpaService,
    private prTypeService: ProductTypeService,
    private prTypeData: PrTypeData,
    private employeeService: EmployeeService,
    private jobService: JobService,
    private companyService: CompanyService,
    private customerBillData: CustomerBillData,
    private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router,
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser.email).subscribe((groups) => {
      permissionsSubs.unsubscribe();
      this.permission = this.permissionService.constructPermissionObject(groups, 'SPECIAL');
      if(!this.permission || !this.permission.rentabilityReport){
        toast('No tiene permisos.', 3000);
        this.router.navigate(['/']);
      }
      else this.allowed = true;
    });
  }

  ngOnInit() {
  }
  ngOnDestroy(){
    for(let subName in this.subs){
      this.subs[subName] && this.subs[subName].unsubscribe();
    }
  }

  async getDocuments(){
    //odp
    let odpPromise = new Promise(r => r());
    if(!this.firstPulled.odps || this.initialDate < this.firstPulled.odps){
      this.firstPulled.odps = this.initialDate;
      this.subs.odps && this.subs.odps.unsubscribe();
      odpPromise = new Promise(resolve => {
        this.subs.odps = this.firestoreService.colWithIds$(this.service.collection, ref => ref.where('active', '==', 1).where('date', '>=', this.initialDate)).subscribe(odps => {
          this.docs.odps = odps;
          resolve();
        });
      });
    }
    //bill
    let billPromise = new Promise(r => r());
    if(!this.subs.bills) billPromise = new Promise(resolve => {
      this.subs.bills = this.firestoreService.colWithIds$(this.billService.collection, ref => ref.where('active', '==', true)).subscribe(bills => {
        this.docs.bills = bills;
        resolve();
      });
    });
    //supBill
    let supBillPromise = new Promise(r => r());
    if(!this.firstPulled.supBills || this.initialDate < this.firstPulled.supBills){
      this.firstPulled.supBills = this.initialDate;
      this.subs.supBills && this.subs.supBills.unsubscribe();
      supBillPromise = new Promise(resolve => {
        this.subs.supBills = this.firestoreService.colWithIds$(this.supBillService.collection, ref => ref.orderBy('date', 'desc').where('active', '==', true).where('date', '>=', this.initialDate)).subscribe(supBills => {
          this.docs.supBills = supBills;
          resolve();
        });
      });
    }
    //expenseCategory
    let expenseCategoryPromise = new Promise(r => r());
    if(!this.subs.expenseCategorys) expenseCategoryPromise = new Promise(resolve => {
      this.subs.expenseCategorys = this.firestoreService.colWithIds$(this.expenseCategoryService.collection, ref => ref.where('active', '==', true)).subscribe(expenseCategorys => {
        this.docs.expenseCategorys = expenseCategorys;
        resolve();
      });
    });
    //odc
    let odcPromise = new Promise(r => r());
    if(!this.subs.odcs) odcPromise = new Promise(resolve => {
      this.subs.odcs = this.firestoreService.colWithIds$(this.odcService.collection, ref => ref.where('active', '==', true)).subscribe(odcs => {
        this.docs.odcs = odcs;
        resolve();
      });
    });
    //prCmpa
    let prCmpaPromise = new Promise(r => r());
    if(!this.subs.prCmpas) prCmpaPromise = new Promise(resolve => {
      this.subs.prCmpas = this.firestoreService.colWithIds$(this.prCmpaService.collection, ref => ref.where('active', '==', true)).subscribe(prCmpas => {
        this.docs.prCmpas = prCmpas;
        resolve();
      });
    });
    //prType
    let prTypePromise = new Promise(r => r());
    if(!this.subs.prTypes) prTypePromise = new Promise(resolve => {
      this.subs.prTypes = this.firestoreService.colWithIds$(this.prTypeService.collection, ref => ref.where('active', '==', true)).subscribe(prTypes => {
        this.docs.prTypes = prTypes;
        resolve();
      });
    });
    //employee
    let employeePromise = new Promise(r => r());
    if(!this.subs.employees) employeePromise = new Promise(resolve => {
      this.subs.employees = this.firestoreService.colWithIds$(this.employeeService.collection, ref => ref.where('active', '==', 1)).subscribe(employees => {
        this.docs.employees = employees;
        resolve();
      });
    });
    //job
    let jobPromise = new Promise(r => r());
    if(!this.subs.jobs) jobPromise = new Promise(resolve => {
      this.subs.jobs = this.firestoreService.colWithIds$(this.jobService.collection, ref => ref.where('active', '==', true)).subscribe(jobs => {
        this.docs.jobs = jobs;
        resolve();
      });
    });
    //company
    let companyPromise = new Promise(r => r());
    if(!this.subs.company) companyPromise = new Promise(resolve => {
      this.subs.company = this.firestoreService.docWithIds$(`${this.companyService.collection}/${this.companyService.companyId}`).subscribe(company => {
        this.docs.company = company;
        resolve();
      });
    });
    await odpPromise;
    await billPromise;
    await supBillPromise;
    await expenseCategoryPromise;
    await odcPromise;
    await prCmpaPromise;
    await prTypePromise;
    await employeePromise;
    await jobPromise;
    await companyPromise;
  }
  async prepareData(){
    this.customerSelect = [{name: 'Todos', value: ''}];
    this.odps = {};
    for(let odp of this.docs.odps){
      if(odp.canceled || odp.date < this.initialDate || odp.date > this.finalDate) continue;
      this.odps[odp.id] = { ...odp, bills: [], odcPrs: [] };
      if(!odp.customer || !odp.customer.id) continue;
      let {id = '', name = ''} = odp.customer;
      if(!this.customerSelect.find(({value}) => value == id)) this.customerSelect.push({name, value: id});
    }
    for(let bill of this.docs.bills){
      if(bill.status >= 'key97' || !this.odps[bill.productionOrderRef.id]) continue;
      this.odps[bill.productionOrderRef.id].bills.push(bill);
    }
    odc:
    for(let odc of this.docs.odcs){
      if(odc.canceled) continue odc;
      pr:
      for(let pr of odc.prForOrders){
        if(!pr.odpId || !this.odps[pr.odpId]) continue pr;
        let prCmpa = this.docs.prCmpas.find(({id}) => id == pr.id);
        let prType = this.docs.prTypes.find(({id}) => prCmpa && id == prCmpa.classnId.id);
        let reportKey: OdcPr['reportKey'] = prType && prType.report != 'key0' && prType.report as OdcPr['reportKey'] || 'key4';
        this.odps[pr.odpId].odcPrs.push({...pr, odcId: odc.id, odcFolio: odc.folio, odcChange: odc.change, reportKey});
      }
    }
  }
  async generateReport(){
    if(!this.initialDate || ! this.finalDate) return;
    this.loaded = false;
    await this.getDocuments();
    await this.prepareData();

    if(this.customerId && !this.customerSelect.find(({value}) => value == this.customerId)) this.customerId = '';

    let totalNumberKeys = ['billsPrUnit','odpQuantity','billsQuantity','billsNdcsSubtotal','mdo','totalExpenses','grossProfit'] /* as const */;
    let totalObjectKeys = ['report','expenseCategorys'] /* as const */;
    let totalsRow: RentabilityRow = {
      odpDate: 'Total',
      odpFolio: '',
      odpShortDescription: '',
      odpStatus: '',
      billsPrUnit: 0,
      odpQuantity: 0,
      billsQuantity: 0,
      quantityPercentage: <null>'',
      billsAmount: 0,
      billsNdcsSubtotal: 0,
      report: this.reportKeys.reduce((acc, cur) => ({...acc, [cur]: 0}), {} as RentabilityRow['report']),
      mdo: 0,
      expenseCategorys: this.docs.expenseCategorys.reduce((acc, cur) => ({...acc, [cur.name]: 0}), {}),
      totalExpenses: 0,
      grossProfit: 0,
      opensModal: false,
    };
    let rentabilityRows: RentabilityRow[] = [];
    for(let odpId in this.odps){
      let odp = this.odps[odpId];
      if(this.customerId && (!odp.customer || odp.customer.id != this.customerId)) continue;

      let billsAmount = 0, billsQuantity = 0, billsNdcsSubtotal = 0;
      for(let bill of odp.bills){
        for(let pr of bill.prForBills){
          billsAmount += pr.amount;
          totalsRow.billsAmount += pr.amount;
          billsQuantity += pr.quantity;
        }
        for(let ndc of bill.creditNotes){
          billsNdcsSubtotal += ndc.subtotal;
        }
      }

      let totalExpenses = 0;
      let report = {} as RentabilityRow['report'];
      for(let key of this.reportKeys) report[key] = 0;
      for(let pr of odp.odcPrs){
        report[pr.reportKey] += pr.amount;
        totalExpenses += pr.amount;
      }
      let mdo = 0, activitys: OdpActivity[] = [...odp.generalActivities];
      for(let section of odp.sections) activitys.push(...section.activities);
      for(let activity of activitys){
        let {dateStart, dateEnd, timeStart, timeEnd} = activity;
        if(!dateStart || !dateEnd || !timeStart || !timeEnd) continue;
        let employee = this.docs.employees.find(({id}) => id == activity.employeeMade);
        let job = this.docs.jobs.find(({id}) => employee && id == employee.jobId);
        if(!job) continue;
        let {baseSalary = 0} = job;
        let hoursWorked = (+Utils.datetimeFromString(dateStart, timeStart) - +Utils.datetimeFromString(dateEnd, timeEnd))/1000/60/60;
        mdo += +(hoursWorked*baseSalary).toFixed(2);
      }
      
      let expenseCategorys: RentabilityRow['expenseCategorys'] = {};
      for(let category of this.docs.expenseCategorys) expenseCategorys[category.name] = 0;
      supBill:
      for(let supBill of this.docs.supBills){
        if(supBill.canceled || supBill.date < this.initialDate || supBill.date > this.finalDate) continue supBill;
        just:
        for(let just of supBill.justifications){
          if(just.purchaseOrderRef) continue just;
          if(!just.concept || !Object.keys(expenseCategorys).includes(just.concept)) continue just;
          expenseCategorys[just.concept] += just.price;
          //totalExpenses += just.price;
        }
      }

      let row: RentabilityRow = {
        odpDate: odp.date,
        odpFolio: odp.name,
        odpShortDescription: odp.shortDescription,
        odpStatus: this.data.statusObjects[odp.status].name,
        billsPrUnit: +(billsAmount/(billsQuantity || 1)).toFixed(4),
        odpQuantity: odp.quantity,
        billsQuantity,
        quantityPercentage: +(100*billsQuantity/(odp.quantity || 1)).toFixed(2),
        billsAmount,
        billsNdcsSubtotal,
        report,
        mdo,
        expenseCategorys,
        totalExpenses,
        grossProfit: billsAmount - billsNdcsSubtotal - totalExpenses,
        opensModal: true,
      };

      
      rentabilityRows.push(row);
    }
    for(let row of rentabilityRows){
      for(let category of this.docs.expenseCategorys){
        let proratedExpense = +(row.expenseCategorys[category.name]*(row.billsAmount/(totalsRow.billsAmount || 1))).toFixed(3);
        row.expenseCategorys[category.name] = proratedExpense;
        row.totalExpenses += proratedExpense;
        row.grossProfit -= proratedExpense;
      }
      for(let key of totalNumberKeys) totalsRow[key] += row[key];
      for(let key of totalObjectKeys) for(let subKey in row[key]) totalsRow[key][subKey] += row[key][subKey];
    }

    this.columns = [];
    for(let columnBone of this._columnBones){
      let columns: Column<RentabilityRow>[];
      let {key, pipe} = columnBone;
      switch(key){
        case 'report':
          columns = this.reportKeys.map(subKey => {
            return {name: this.prTypeData.reports[subKey], key, subKey, pipe};
          });
          break;
        case 'expenseCategorys':
          columns = this.docs.expenseCategorys.map(({name: subKey}) => {
            return {name: subKey, key, subKey, pipe};
          });
          break;
        default:
          columns = [columnBone];
          break;
      }
      this.columns.push(...columns);
    }

    this.sorter = new RowSorter(rentabilityRows, 'odpDate', 'desc');
    this.sorter.finalRows = [totalsRow];
    console.log(this.sorter.rows);
    window['THIS'] = this;

    this.loaded = true;
  }



  onExcel(){
    //console.log('___', this.rows.map(({empId, cName, odcs, bills, ...row}) => row));
    let excel = [
      [`${this.docs.company.name} - Reporte de rentabilidad - ${this.initialDate.replace(/-/g, '/')} al ${this.finalDate.replace(/-/g, '/')}`],
      [],
      this.columns.map(({name}) => name),
      ...this.sorter.rows.map(row => this.columns.map(({key, subKey}) => subKey ? row[key][subKey] : row[key] )),
    ];
    Utils.downloadExcel(excel, `ReporteRentabilidad${this.initialDate}a${this.finalDate}`.replace(/-/g, ''));
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////Show
  modalActionsShow = new EventEmitter<string|MaterializeAction>();
  modalParamsShow = [{dismissible: true}];

  currentShow: {bills: Odp['bills'], odcPrs: Odp['odcPrs'], billsTotals, odcPrsTotals,};

  openModalShow(row: RentabilityRow) {
    let odp = Object.values(this.odps).find(odp => odp.name == row.odpFolio);
    if(!odp) return;
    this.currentShow = {
      bills: odp.bills,
      odcPrs: odp.odcPrs,
      billsTotals: odp.bills.reduce((acc, cur) => {
        acc.sub += cur.totals.subtotal * (cur.change || 1);
        acc.total += cur.totals.total * (cur.change || 1);
        return acc;
      }, {sub: 0, get iva(){return this.total - this.sub}, total: 0}),
      odcPrsTotals: odp.odcPrs.reduce((acc, cur) => {
        acc.sub += cur.amount * (cur.odcChange || 1);
        acc.total += cur.amount*(1 + cur.amountIva/100) * (cur.odcChange || 1);
        return acc;
      }, {sub: 0, get iva(){return this.total - this.sub}, total: 0})
    };
    this.modalActionsShow.emit({ action: 'modal', params: ['open'] });
  }
  closeModalShow() {
    this.currentShow = undefined;
    this.modalActionsShow.emit({ action: 'modal', params: ['close'] });
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////Show
  onPdfExport(){
  }

}
